import { createRouter, createWebHistory, type RouteLocationGeneric } from 'vue-router';
import AmlReviewQueuePage from '@/pages/AmlReviewQueuePage.vue';
import AmlReviewCasePage from '@/pages/AmlReviewCasePage.vue';
import CardsPage from '@/pages/CardsPage.vue';
import CardPage from '@/pages/CardPage.vue';
import CardSeriesPage from '@/pages/CardSeriesPage.vue';
import FundingSourcesPage from '@/pages/FundingSourcesPage.vue';
import FundingSourcePage from '@/pages/FundingSourcePage.vue';
import PaymentPage from '@/pages/PaymentPage.vue';
import ConfigPage from '@/pages/ConfigPage.vue';
import StylesPage from '@/pages/StylesPage.vue';
import ComponentsPage from '@/pages/ComponentsPage.vue';
import CookieAuthTestPage from '@/pages/CookieAuthTestPage.vue';
import AuthRedirectPage from '@/pages/AuthRedirectPage.vue';
import AuthResumePage from '@/pages/AuthResumePage.vue';
import LoginPage from '@/pages/LoginPage.vue';
import UnauthorisedPage from '@/pages/UnauthorisedPage.vue';
import NotFound from '@/pages/NotFound.vue';
import { beforeEachGuard } from '@/routes/guards/beforeEachGuard';

const routes = [
  { path: '/', redirect: '/aml-review' },
  { path: '/aml-review', redirect: '/aml-review/status/escalated' },
  {
    path: '/redirect/zendesk/aml-reviews',
    redirect: (to: RouteLocationGeneric) => ({ path: `/aml-review/${to.query.id}`, query: {} }),
  },
  {
    path: '/aml-review/status/:status',
    component: AmlReviewQueuePage,
    meta: { requiresAuth: true },
  },
  { path: '/aml-review/:id', component: AmlReviewCasePage, meta: { requiresAuth: true } },
  {
    path: '/cards',
    component: CardsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/cards/:cardId',
    component: CardPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/card-series',
    component: CardSeriesPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/funding-sources',
    component: FundingSourcesPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/funding-sources/:fundingSourceId',
    component: FundingSourcePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/payments',
    component: PaymentPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/payments/:paymentId',
    component: PaymentPage,
    meta: { requiresAuth: true },
  },
  { path: '/login', component: LoginPage },
  { path: '/unauthorised', component: UnauthorisedPage },
  { path: '/auth/redirect', component: AuthRedirectPage },
  { path: '/auth/resume', component: AuthResumePage },
  { path: '/config', component: ConfigPage },
  { path: '/utilities/styles', component: StylesPage },
  { path: '/utilities/components', component: ComponentsPage },
  { path: '/utilities/cookie-auth-test', component: CookieAuthTestPage },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(beforeEachGuard);
